import Topic from "common/managers/topic/Topic";

const CrossTabTopic = function() {
    let channel = null;
    const disconnect = () => {
        channel.close();
        channel = null;
    };
    const connect = () => {
        channel = new BroadcastChannel(`CrossTabTopic:${context.path}`);
        channel.onmessage = (e) => {
            Topic.prototype.publish.apply(this, e.data);
        }
    };
    this.publish = (...args) => {
        if(channel === null) {
            connect();
        }
        channel.postMessage(args);
        Topic.prototype.publish.apply(this, structuredClone(args));
    }
    this.init(eventCount => {
        if (eventCount === 0 && channel !== null) {
            disconnect();
        } else if (eventCount === 1 && channel === null) {
            connect();
        }
    });
}

CrossTabTopic.prototype = Object.create(Topic.prototype);

export default CrossTabTopic;
